import $ from 'jquery'
import Vue from 'vue'
import i18n from './plugins/vue-i18n'
import vuetify from './plugins/vuetify'
import store from './store'

import PetitionSearchBox from './shared-vue-components/ui/petitionSearchBox.vue'

$(document).ready(() => {
  // Initialise Vue
  Vue.config.productionTip = false

  const petitionSearchEl = document.getElementById('petition_search_box')
  const petitionSearchProps = {
    ...JSON.parse(petitionSearchEl.getAttribute('data')),
    ...$(petitionSearchEl).data()
  }

  if (petitionSearchEl && petitionSearchProps) {
    new Vue({
      render: h => h(PetitionSearchBox, { props: petitionSearchProps }),
      i18n,
      vuetify,
      store
    }).$mount(petitionSearchEl)
  } else if (!petitionSearchEl) {
    // eslint-disable-next-line no-console
    console.warn('No petition_search_box on this page.')
  } else if (!props) {
    // eslint-disable-next-line no-console
    console.warn('No data- specificed petition_search_box on this page.')
  }
})
